import React from 'react';
import { connect } from 'react-redux';
import ResponsiveEmbed from 'react-responsive-embed';
import { GoogleApiKey } from '../../App_Data/ClesAPI';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import Adresse from '../Adresse';

const CardAdresse = ({ Adr, Recherche }) => (
    <Card Titre="Son adresse">
        <div className="card-text">
            <ResponsiveEmbed
                src={`https://www.google.com/maps/embed/v1/search?key=${GoogleApiKey}&q=${Recherche}&zoom=18`}
            />
            <Adresse className="mt-3" {...Adr} />
        </div>
    </Card>
);

CardAdresse.displayName = 'CardAdresse';
CardAdresse.titleName = 'Son adresse';
CardAdresse.requiredProps = [
    'Adr', // Adresse du syndic
    'Recherche', // Paramètre de recherche
];

function mapStateToProps({
    SynStore: {
        Syn: { Ind },
    },
}) 

{
    return { Adr: Ind.Adresse, 
        Recherche: `${Ind.Nom.replace(/[&#,+()$~%:*?<>{}|]/g, ' ')}
            ,${Ind.Adresse.RefRech}` 
    };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardAdresse));



// WEBPACK FOOTER //
// ./src/components/MonSyndic/CardAdresse.js